class ClientController {
  constructor() {
    this.name = 'client';
  }
}

export default ClientController;



// WEBPACK FOOTER //
// ./client/app/components/client/client.controller.js